export default "__VITE_ASSET__263d7a70__"